module.exports = __webpack_public_path__ + "static/media/megan_benoit.115e762a.jpg";